const observer = new MutationObserver(function(mutations) {
    const redoApp = document.querySelector("redo-shopify-toggle")
    if (redoApp) {
        observer.disconnect()

        const shadowRoot = redoApp.shadowRoot
        if (shadowRoot) {
            const styleElement = document.createElement("style")
            styleElement.textContent = `
              [data-target="non-coverage-button"],
              [data-target="non-coverage-button"]:hover,
              [data-target="coverage-button"],
              [data-target="coverage-button"]:hover {
                border-radius: 15px !important;
                height: 58px !important;
              }
              [data-target="info-card-container"] {
                margin-top: 3px !important;
              }
              [data-target="non-coverage-button"] > p,
              [data-target="coverage-button"] * {
                font-size: 17px !important;
                font-weight: 500 !important;
                font-family: "Inter", sans-serif !important;
              }
              [data-target='toggle-subtext'] {
                font-size: 13px !important;
                font-weight: 400 !important;
                font-family: "Inter", sans-serif !important;
              }
              [data-target='toggle-label'] {
                font-size: 16px !important;
                font-weight: 500 !important;
                margin-bottom: 4px !important;
                font-family: "Inter", sans-serif !important;
                display: inline-block !important;
              }
              [data-target="text-and-buttons-container"] {
                display: flex !important;
                align-items: end !important;
              }
              [data-target="price"] {
                font-size: 0.95em !important;
                height: 100%;
                display: flex;
                align-items: end;
              }
            `
            shadowRoot.appendChild(styleElement)
        }
    }
})

observer.observe(document.body, {
    childList: true,
    subtree: true
})

const openCartDrawer = (e) => {
    if (e && typeof e.preventDefault === 'function') {
        e.preventDefault();
    }
    const cartContainer = document.querySelector("#shopify-section-cart-drawer")
    if (cartContainer) {
        cartContainer.classList.add("active")
        
        // --- Advanced Scroll Lock ---
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
    }
}

const closeCartDrawer = () => {
    const cartContainer = document.querySelector("#shopify-section-cart-drawer")
    if (cartContainer) {
        cartContainer.classList.remove("active")
        
        // --- Advanced Scroll Unlock ---
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
}

function ajaxSubmitCart(cart) {
    const $cart = cart
    $.ajax({
        url: "/cart/update.js",
        dataType: "json",
        cache: false,
        type: "post",
        data: $cart.serialize(),
        success(data) {
            refreshCartWithSectionRendering()
        }
    })
}

function updateCartItemQuantity(cartItem) {
    $.ajax({
        url: "/cart/change.js",
        dataType: "json",
        cache: false,
        type: "post",
        data: {
            quantity: cartItem.quantity,
            line: cartItem.lineID
        },
        success(data) {
            const cartItemsArray = data.items
            const lineIDIndex = cartItem.lineID - 1
            const totalCartItems = cartItem.parentCartForm.find("[data-variant-id]").length
            const $quantityInputs = cartItem.parentCartForm.find(
                `[data-variant-id="${cartItem.variantID}"] input`
            )
            let initialQuantityTotal = 0
            let apiQuantityTotal = 0
            const apiLineItemQuantity =
                typeof data.items[lineIDIndex] !== "undefined" ? data.items[lineIDIndex].quantity : 0

            if ($quantityInputs.length > 1) {
                $.each($quantityInputs, (_i, input) => {
                    initialQuantityTotal += parseInt($(input).val())
                })
                cartItemsArray.forEach(item => {
                    if (item.variant_id === cartItem.variantID) {
                        apiQuantityTotal += item.quantity
                    }
                })
            } else {
                initialQuantityTotal = parseInt($quantityInputs.val())
                apiQuantityTotal =
                    typeof data.items[lineIDIndex] !== "undefined" ? data.items[lineIDIndex].quantity : 0
            }

            if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
                if (apiQuantityTotal === 1) {
                    itemsLeftText = window.PXUTheme.translation.one_item_left
                } else {
                    itemsLeftText = window.PXUTheme.translation.items_left_text
                }

                $(".warning--quantity").remove()

                if (totalCartItems < cartItemsArray.length) {
                    if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
                        cartItem.parentCartForm.submit()
                    } else {
                        refreshCartWithSectionRendering()
                    }
                } else {
                    const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`
                    cartItem.parentCartForm
                        .find(`[data-line-id='${cartItem.lineID}'] input`)
                        .parent()
                        .after(warning)
                    cartItem.parentCartForm
                        .find(`[data-line-id='${cartItem.lineID}'] input`)
                        .val(apiLineItemQuantity)
                }
            } else if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
                cartItem.parentCartForm.submit()
            } else {
                refreshCartWithSectionRendering()
            }
        }
    })
}

function refreshCartID() {
    const cartItem = document.querySelectorAll(".cart__item")
    for (let i = 0; i < cartItem.length; i++) {
        const lineIndex = i + 1
        const dataLineId = cartItem[i].querySelectorAll("[data-line-id]")
        for (let c = 0; c < dataLineId.length; c++) {
            dataLineId[c].dataset.lineId = lineIndex
        }
    }
}

function refreshCartWithSectionRendering() {
    fetch("/cart.js")
        .then(response => response.json())
        .then(cart => {
            const $cartBtn = $(".cart_count")
            const value = $cartBtn.text() || "0"
            $cartBtn.text(value.replace(/[0-9]+/, cart.item_count))
            return fetch(`${window.location.pathname}?sections=cart-drawer`)
        })
        .then(response => response.json())
        .then(sections => {
            const cartDrawerHTML = sections["cart-drawer"]
            const $cartDrawer = $("#shopify-section-cart-drawer")
            const $tempContainer = $("<div>").html(cartDrawerHTML)
            const $newCartDrawer = $tempContainer.find(".cart-drawer")

            // --- NEW: Check if pending code actually rendered in the HTML ---
            // Inside refreshCartWithSectionRendering()
// --- NEW: Check if pending code actually rendered in the HTML ---
            const pendingCode = sessionStorage.getItem('pending_discount_code');
            if (pendingCode) {
                let codeFound = false;
                
                // 1. Check if Shopify rendered it as a standard cart/item discount
                $newCartDrawer.find('.discount-pill__code').each(function() {
                    if ($(this).text().trim().toLowerCase() === pendingCode.toLowerCase()) {
                        codeFound = true;
                    }
                });

                // 2. NEW: Check if it's a Klaviyo Free Shipping code using your "FS-" prefix
                const isFreeShippingCode = pendingCode.toUpperCase().startsWith('FS-');

                // 3. Apply logic
                if (codeFound || isFreeShippingCode) {
                    let successMsg = `Code '${pendingCode}' Applied!`;
                    
                    // Optional: Give them specific feedback so they know why the price didn't drop in the cart
                    if (isFreeShippingCode && !codeFound) {
                        successMsg = `Free Shipping Code Applied! (Will Reflect At Checkout)`;
                    }
                    
                    sessionStorage.setItem('discount_message', successMsg);
                    sessionStorage.setItem('discount_code', pendingCode);
                } else {
                    sessionStorage.setItem('discount_error', `Code '${pendingCode}' Is Invalid. Please Note: Gift Cards Must Be Applied At Checkout.`);
                    sessionStorage.removeItem('discount_code'); // Clear the bad code
                }
                sessionStorage.removeItem('pending_discount_code');
            }
            // ----------------------------------------------------------------
            // ----------------------------------------------------------------

            $cartDrawer.find(".cart-drawer").replaceWith($newCartDrawer)
            
            bindCartDrawerEvents()
            syncCartDrawerQuantityButtons()
            restoreDiscountCode() // Restore UI after HTML resets

            if (window.PXUTheme.currency && window.PXUTheme.currency.show_multiple_currencies) {
                window.currencyConverter.convertCurrencies()
            }

            openCartDrawer()
        })
        .catch(error => {
            console.error("Error refreshing cart:", error)
        })
}

function bindCartDrawerEvents() {
    const cartClose = document.querySelector(".cart-close")
    if (cartClose) {
        cartClose.removeEventListener("click", closeCartDrawer)
        cartClose.addEventListener("click", closeCartDrawer)
    }

    const overlay = document.querySelector(".cart-overlay")
    if (overlay) {
        overlay.removeEventListener("click", closeCartDrawer)
        overlay.addEventListener("click", closeCartDrawer)
    }
}

function syncCartDrawerQuantityButtons() {
    $("[data-cart-form='mini-cart'] [data-cart-quantity-input]").each(function() {
        const $input = $(this)
        const value = parseInt($input.val(), 10)
        const minAttr = parseInt($input.attr("min"), 10)
        const maxAttr = $input.attr("max")
        const max = maxAttr != null ? parseInt(maxAttr, 10) : null
        const min = Number.isNaN(minAttr) ? 0 : minAttr
        const safeValue = Number.isNaN(value) ? min : value
        const $box = $input.closest(".product-quantity-box")
        const $minus = $box.find(".product-minus")
        const $plus = $box.find(".product-plus")

        $minus.toggleClass("is-disabled", safeValue <= min)
            .attr("aria-disabled", safeValue <= min ? "true" : "false")

        if (max === null || Number.isNaN(max)) {
            $plus.removeClass("is-disabled").attr("aria-disabled", "false")
        } else {
            $plus.toggleClass("is-disabled", safeValue >= max)
                .attr("aria-disabled", safeValue >= max ? "true" : "false")
        }
    })
}

$("body").on("change", "[data-cart-quantity-input]", function() {
    const $parentCartForm = $(this).parents("[data-cart-form]")
    if ($parentCartForm.data("cart-form") !== "mini-cart") {
        return
    }

    const cartItem = {
        lineID: $(this).parents("[data-cart-item]").data("line-id"),
        variantID: $(this).parents("[data-cart-item]").data("variant-id"),
        quantity: $(this).val(),
        parentCartForm: $parentCartForm,
        totalDiscount: $parentCartForm.data("total-discount"),
        $element: $(this).parents("[data-cart-item]")
    }
    $(this).parents(".product-quantity-box").find(".js-change-quantity").addClass("is-disabled")
    syncCartDrawerQuantityButtons()
    updateCartItemQuantity(cartItem)
})

$("body").on("click", "[data-remove-item]", function(e) {
    const $parentCartForm = $(this).parents("[data-cart-form]")
    if ($parentCartForm.data("cart-form") !== "mini-cart") {
        return
    }

    e.preventDefault()
    const cartItem = {
        lineID: $(this).parents("[data-cart-item]").data("line-id"),
        variantID: $(this).parents("[data-cart-item]").data("variant-id"),
        quantity: 0,
        parentCartForm: $parentCartForm,
        totalDiscount: $parentCartForm.data("total-discount"),
        $element: $(this).parents("[data-cart-item]")
    }

    updateCartItemQuantity(cartItem)

    if (cartItem.parentCartForm.data("cart-form") === "cart-template") {
        cartItem.$element.find("input").val("0")
        cartItem.parentCartForm.submit()
    }

    if (cartItem.parentCartForm.data("cart-form") === "mini-cart") {
        cartItem.$element.find("input").val("0")
    }
})

if (window.PXUTheme.theme_settings.cart_action === "ajax") {
    $(document).on("click", ".ajax-submit", function(e) {
        e.preventDefault()
        const $addToCartForm = $(this).closest("form")
        const $addToCartBtn = $addToCartForm.find(".add_to_cart")

        if ($("body").hasClass("cart")) {
            $addToCartForm.submit()
        }

        $.ajax({
            url: "/cart/add.js",
            dataType: "json",
            cache: false,
            type: "post",
            data: $addToCartForm.serialize(),
            beforeSend() {
                $addToCartBtn.attr("disabled", "disabled").addClass("disabled")
                $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut")
            },
            success() {
                $addToCartBtn.find(".checkmark").addClass("checkmark-active")
                refreshCartWithSectionRendering()
                window.setTimeout(() => {
                    $addToCartBtn.removeAttr("disabled").removeClass("disabled")
                    $addToCartBtn.find(".checkmark").removeClass("checkmark-active")
                    $addToCartBtn.find("span").removeClass("zoomOut").addClass("fadeInDown")
                }, 1000)

                openCartDrawer()
            },
            error(XMLHttpRequest) {
                let response = eval(`(${XMLHttpRequest.responseText})`)
                response = response.description
                $(".warning").remove()

                const warning = `<p class="warning animated bounceIn">${response.replace("All 1 ", "All ")}</p>`
                $addToCartForm.after(warning)
                $addToCartBtn.removeAttr("disabled").removeClass("disabled")
                $addToCartBtn.find("span").text(window.PXUTheme.translation.add_to_cart).removeClass("zoomOut").addClass("zoomIn")
            }
        })

        return false
    })
}

class CartTrigger extends HTMLElement {
    init() {
        this.addEventListener("click", openCartDrawer)
    }
    connectedCallback() {
        this.init()
    }
}

customElements.define("cart-trigger", CartTrigger)

// ==========================================
// DISCOUNT CODE LOGIC (AJAX Application)
// ==========================================

// 1. APPLY DISCOUNT BUTTON
$("body").on("click", ".js-apply-discount", function(e) {
    e.preventDefault();
    const $container = $(this).closest('.cart-discount-container');
    const code = $container.find('.cart-discount-input').val().trim();
    const $btn = $(this);
    const $message = $container.find('.cart-discount-message');

    if (code) {
        $btn.text('...').css('opacity', '0.7').prop('disabled', true);
        $message.removeClass('success error').text(''); // Clear old messages
        
        fetch(`/discount/${code}`)
            .then(() => {
                // Store as pending instead of blindly trusting Shopify
                sessionStorage.setItem('pending_discount_code', code);
                refreshCartWithSectionRendering();
            })
            .catch(error => {
                console.error('Error applying discount:', error);
                $btn.text('Apply').css('opacity', '1').prop('disabled', false);
            });
    }
});

// 2. REMOVE DISCOUNT BUTTON
$("body").on("click", ".js-remove-discount", function(e) {
    e.preventDefault();
    const $btn = $(this);
    
    // Dim the pill so the user knows it's loading
    $btn.closest('.discount-pill').css('opacity', '0.4').css('pointer-events', 'none');

    // Force-delete Shopify's local discount cookie
    document.cookie = "discount_code=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";

    // Ping the checkout explicitly passing a blank discount parameter. 
    fetch('/checkout?discount=', { mode: 'no-cors' })
        .then(() => {
            // Clear all local storage records of the code
            sessionStorage.removeItem('discount_code');
            sessionStorage.removeItem('discount_message');
            
            // Set a message to let the user know it was wiped
            sessionStorage.setItem('discount_error', 'Discount removed.'); 
            
            // Reload the cart HTML so prices instantly go back to normal
            refreshCartWithSectionRendering();
        })
        .catch(error => {
            console.error('Error clearing discount:', error);
            $btn.closest('.discount-pill').css('opacity', '1').css('pointer-events', 'auto');
        });
});

// 3. RESTORE UI AFTER REFRESH
function restoreDiscountCode() {
    const $input = $('.cart-discount-input');
    const $message = $('.cart-discount-message');
    
    const msg = sessionStorage.getItem('discount_message');
    const errorMsg = sessionStorage.getItem('discount_error');
    const savedCode = sessionStorage.getItem('discount_code');

    // Handle Messages
    if (msg && $message.length) {
        $message.text(msg).removeClass('error').addClass('success');
        sessionStorage.removeItem('discount_message'); 
    } else if (errorMsg && $message.length) {
        $message.text(errorMsg).removeClass('success').addClass('error');
        sessionStorage.removeItem('discount_error');
    }
    
    // Handle Input Field
    if (savedCode && $input.length) {
        $input.val(savedCode);
    } else if (!savedCode && $input.length) {
        $input.val(''); // Empty the field if the code failed
    }
    
    // If a valid code is rendered in the UI from checkout, populate it
    const $appliedDiscountText = $('.discount-pill__code');
    if ($appliedDiscountText.length && $appliedDiscountText.text().trim() !== '') {
        $input.val($appliedDiscountText.first().text().trim());
    }
}

// ==========================================
// INIT DRAWER
// ==========================================
const initCartDrawer = () => {
    const cartClose = document.querySelector(".cart-close")
    const overlay = document.querySelector(".cart-overlay")
    const cartDrawerTrigger = document.querySelectorAll("[data-cart-drawer-trigger]")

    const initTriggers = () => {
        if (cartDrawerTrigger.length > 0) {
            cartDrawerTrigger.forEach(trigger => {
                trigger.removeEventListener("click", openCartDrawer)
                trigger.addEventListener("click", openCartDrawer)
            })
        }
    }

    document.addEventListener("stickyNavInitialized", () => {
        initTriggers()
    })
    
    initTriggers()

    if (cartClose) {
        cartClose.removeEventListener("click", closeCartDrawer)
        cartClose.addEventListener("click", closeCartDrawer)
    }

    if (overlay) {
        overlay.removeEventListener("click", closeCartDrawer)
        overlay.addEventListener("click", closeCartDrawer)
    }
    
    restoreDiscountCode()
    syncCartDrawerQuantityButtons()
}

initCartDrawer()
